import { render, staticRenderFns } from "./home.vue?vue&type=template&id=18fa4b52&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.scss?vue&type=style&index=0&id=18fa4b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa4b52",
  null
  
)

export default component.exports